export class YDebounced<T> {
    on_change?: (from: T, to: T) => void;

    private _value: T;
    private _id?: number;
    private _delay: number;

    constructor(delay: number, initial: T) {
        this._delay = delay;
        this._value = initial;
    }

    set value(v: T) {
        if(this._id) {
            clearTimeout(this._id);
        }

        this._id = setTimeout(() => {
            this._id = undefined;
            if(v !== this._value) {
                const old = this._value;
                this._value = v;
                this.on_change && this.on_change(old, v);
            }
        }, this._delay * 1000);
    }

    get value() {
        return this._value;
    }
}
